import { Component } from '@angular/core';

@Component({
    selector: 'regimen-sop',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class RegimenSopComponent {}
